import { isValidElement } from "react";
import { type Element } from ".";

export function isRenderable(arg: unknown): arg is Element {
  return (
    arg === null ||
    arg === undefined ||
    typeof arg === "number" ||
    typeof arg === "string" ||
    typeof arg === "boolean" ||
    Array.isArray(arg) ||
    isValidElement(arg)
  );
}
